import React from 'react';
import { useSelector } from 'react-redux';
import * as call from '../../../../call';
import { IconSizes, IconVariants } from '../../../constants';
import ButtonNPI from '../../ButtonNPI';
const NpiIconControl = () => {
    const currentParticipant = useSelector(call.selectors.getCurrentParticipant);
    const hasNpiIcon = useSelector((state) => {
        if (!currentParticipant) {
            return false;
        }
        return call.selectors.hasParticipantNpiIcon(state, currentParticipant.uuid);
    });
    if (!hasNpiIcon) {
        return null;
    }
    return (<ButtonNPI size={IconSizes.Medium} variant={IconVariants.Plain} disabled={true}/>);
};
export const NpiIconControlKey = 'npi-icon-control';
export default NpiIconControl;
